export default function getNextMonth() {
  const presentMonth = new Date().getMonth() + 1;
  let nextMonth = presentMonth + 1;
  if (nextMonth > 12) {
    return 1;
  } else {
    return nextMonth;
  }
}
